import { useState } from 'react';

export default function useMessageHandler() {
    const [messages, setMessages] = useState<Message[]>([]);

    async function submitMessage(userInput: string): Promise<void> {
        if (userInput === '') return;
        // Create request body before update
        const requestBody = {
            query: userInput,
            history: messages.flatMap(({ user, model }) => [
                {
                    role: 'user',
                    content: user,
                },
                {
                    role: 'model',
                    content: model,
                },
            ]),
        };
        setMessages((prev) => [...prev, { user: userInput, model: '', datasources: [] }]);

        try {
            const response = await fetch('/chat', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: 'Bearer dedea584-68ea-4a88-964c-bcc6971aee1b',
                },
                credentials: 'include',
                body: JSON.stringify(requestBody),
            });
            if (response.status === 429) {
                throw new Error('budget_exceeded');
            }
            if (!response.ok) {
                throw new Error('Server returned non successful status code');
            }
            const body = response.body;
            if (!body) {
                throw new Error('Server returned a response but it did not contain body');
            }
            const reader = body.getReader();
            const decoder = new TextDecoder();
            await reader
                .read()
                .then(function processText(
                    data: ReadableStreamReadResult<Uint8Array>
                ): Promise<void> | void {
                    // Result objects contain two properties:
                    // done  - true if the stream has already given you all its data.
                    // value - some data. Always undefined when done is true.
                    if (data.done) {
                        return;
                    }
                    const decoded = decoder.decode(data.value);

                    const chunks = parseChunk(decoded);
                    for (const chunk of chunks) {
                        setMessages((prev) => {
                            const newMessages = [...prev];
                            const lastIndex = newMessages.length - 1;
                            const targetMessage = newMessages[lastIndex];
                            const newMsg = {
                                ...targetMessage,
                            };

                            if ('text' in chunk) {
                                newMsg.model = newMsg.model + chunk.text;
                            }

                            if ('datasources' in chunk) {
                                newMsg.datasources = [...newMsg.datasources, ...chunk.datasources];
                            }

                            newMessages[lastIndex] = newMsg;
                            return newMessages;
                        });
                    }
                    // Read some more, and call this function again
                    return reader.read().then((item) => processText(item));
                })
                .catch((error) => {
                    throw error;
                });
        } catch (error) {
            console.log(error);
            // Removing the latest
            setMessages((prev) => {
                // Remove the second message
                // Reverse to find the first user message from the last index
                return [...prev].slice(0, -1);
            });
            // Re-throwing
            throw error;
        }
    }

    function resetThread() {
        setMessages([]);
    }

    return {
        submitMessage,
        resetThread,
        messages,
    };
}

function parseChunk(data: string): ResponseChunk[] {
    //const incomingChunk: ResponseChunk = JSON.parse(decoded);
    const divided = '[' + data.replace(/}{/g, '},{') + ']';
    const parsed = JSON.parse(divided);
    return parsed;
}
